import React from "react";
import MessageEventNotification from "./MessageEventNotification";
import GeneralNotification from "./GeneralNotification";

function Notification({ notification }) {
    if (!notification) {
        return null;
    }

    if (notification.identityToNotify !== undefined) {
        return <MessageEventNotification notification={notification} />;
    }

    if (notification.metadata !== undefined) {
        return <GeneralNotification notification={notification} />;
    }

    return null;
}

export default Notification;
